import { Maybe } from "@instacover/utils"

export const queryKeys = {
  navigatorPermissions: (permission: PermissionName) => ["navigatorPermissions", permission],
  videoConstraints: ["video-constraints"],

  onnxModel: (modelUrl: string) => ["onnx-model", modelUrl],
  onnxModelResult: (file: Maybe<File>) => ["file-model-result", file?.name, file?.size, file?.lastModified],
} as const
